import { render, staticRenderFns } from "./MainareaModel.vue?vue&type=template&id=1f0d4376&scoped=true"
import script from "./MainareaModel.vue?vue&type=script&lang=js"
export * from "./MainareaModel.vue?vue&type=script&lang=js"
import style0 from "./MainareaModel.vue?vue&type=style&index=0&id=1f0d4376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0d4376",
  null
  
)

export default component.exports